// extracted by mini-css-extract-plugin
export default {"tabList":"Tabs_tabList__uOj07","tabContent":"Tabs_tabContent__alaHx"};